import { useMemo } from 'react';

import { getStringWithoutHash } from 'utilitys/helpers/general';

import useCustomPageSubTitle from 'hooks/useCustomPageSubTitle';

import { getDataForStatusBar } from 'components/common/CustomizedStatusBar/CustomizedStatusBar.utils';

export const useMyTrackedActivitiesWidgetLogic = ({ id, api, ui }) => {
    const route = `${getStringWithoutHash(window.location.href)}#${id}`;
    const subTitle = useCustomPageSubTitle({
        projectId: ui.state.projectId,
        contractId: ui.state.contractId,
        latestVersionId: ui.state.latestVersionId,
    });

    const activeData = useMemo(() => {
        if (api.getSummaryTrackedActivities.data) {
            const current = api.getSummaryTrackedActivities.data.periodItemsList.find((item) => item.id === 'all');
            return current ? current.itemsList : [];
        }
        return [];
    }, [api.getSummaryTrackedActivities.data]);

    const statusBarData = getDataForStatusBar(
        activeData.map((item) => item.latestVersion.cardBoardViewResponse.status.label),
    );

    return {
        logic: {
            route,
            subTitle,
            activeData,
            statusBarData,
        },
    };
};
